import { render, staticRenderFns } from "./lvFooter.vue?vue&type=template&id=77a9a0c6&"
import script from "./lvFooter.vue?vue&type=script&lang=js&"
export * from "./lvFooter.vue?vue&type=script&lang=js&"
import style0 from "./lvFooter.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports